import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

import {
    searchEntityRequest,
    unitTypeRequest,
    clearRedux,
} from 'Redux/actions';

const DeleteUnitTypes = (props) => {
    const { tableRef } = props;
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const { openModal, loading, result, unitType } = useSelector(state => state.deleteUnitTypeRedux);

    const closeModal = () => {
        dispatch(clearRedux("DELETE_UNITTYPES"));
    }

    const applyChanges = () => {
        dispatch(unitTypeRequest(unitType?.id));
    }

    useEffect(() => {
        if (result) {
            if (result?.delete) {
                closeModal();
                NotificationManager.success(
                    messages['delete_unittype_success_message'],
                    messages['delete_unittype_title'],
                    3000
                );
                dispatch(searchEntityRequest({ key: "unitTypes" }))
                tableRef && tableRef?.current?.getData();
            }
            else {
                let message = messages['delete_unittype_error_message']
                if(result && result?.error && result?.error?.includes("in use")){
                    message = messages['delete_unittype_in_use']
                }
                NotificationManager.error(
                    message,
                    messages['delete_unittype_title'],
                    3000
                );
                dispatch(clearRedux("DELETE_UNITTYPES", { result: null }));
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={`${messages['delete_unittype_title']} ${unitType?.name ? `(${unitType?.name})` : ""}`}
            loading={loading}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <label style={{ marginBottom: 5 }}>
                        {messages['delete_unittype_label']}
                    </label>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteUnitTypes;